import { Box, Button, Checkbox, Typography } from '@mui/material';
import { useMemo } from 'react';
import { BillingPagination, ClinicConfig } from '../../../interfaces/billing.rpm';
import { CompactTable } from '../../common/CompactTable/CompactTable';
import { Column } from '../../common/CustomTable';

export type AddClinicProps = {
  clinics: ClinicConfig[];
  pagination: BillingPagination;
  onSaveClinicEnabledUpdate: (clinicId: number, currentState: boolean) => void;
  onEditClinic: (clinicId: number) => void;
  onPageChange: (page: number) => void;
  onRowsPerPageChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

export const ClinicConfigurationList: React.FC<AddClinicProps> = ({
  clinics,
  pagination,
  onSaveClinicEnabledUpdate,
  onEditClinic,
  onPageChange,
  onRowsPerPageChange,
}) => {
  const columns: Column[] = useMemo(() => {
    return [
      {
        key: 'clinicId',
        label: 'Clinic ID',
      },
      {
        key: 'payerId',
        label: 'Payer ID',
      },
      {
        key: 'rpmEnabled',
        label: 'Enabled',
      },
      {
        key: 'actions',
        label: 'Edit',
        align: 'center',
      },
    ];
  }, []);

  const tableRows = useMemo(() => {
    return clinics.map((row) => ({
      clinicId: <Typography variant='subtitle2'>{row.clinicId}</Typography>,
      payerId: <Typography variant='subtitle2'>{row.payerId}</Typography>,
      rpmEnabled: (
        <Checkbox
          checked={row.rpmEnabled}
          onChange={(e) => onSaveClinicEnabledUpdate(row.id!, e.target.checked)}
        />
      ),
      actions: (
        <Button variant='contained' color='primary' onClick={(e) => onEditClinic(row.id!)}>
          Edit
        </Button>
      ),
    }));
  }, [clinics, onSaveClinicEnabledUpdate, onEditClinic]);

  return (
    <Box position='relative' sx={{ margin: 5 }}>
      <Typography variant='subtitle1'>CLINICS CONFIGURATION</Typography>
      <CompactTable
        columns={columns}
        rows={tableRows}
        defaultText='No clinics'
        pagination={{
          rowsPerPageOptions: [10, 20, 30, 50],
          rowPerPage: pagination.limit,
          page: pagination.currentPage,
          totalCount: pagination.totalCount,
          onPageChange,
          onRowsPerPageChange,
        }}
      />
    </Box>
  );
};
